import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      const ud = localStorage.getItem('auth');
      if (ud != null) {
        const ud_json = JSON.parse(ud);
        const expr = ud_json && (ud_json.expr != null) ? parseInt(ud_json.expr, 10) : null;
        if (expr != null && !isNaN(expr) && expr < Date.now()) {
          this.authService.logout();
          return next.handle(req);
        }
      }
    } catch (e) {
      localStorage.removeItem('auth');
    }

    const isLogin = req.url.indexOf('/v1/auth/login') >= 0;
    if (!isLogin && this.authService.isAuthenticated() && req.url.indexOf(environment.apiBaseUrl) >= 0) {
      const token = this.authService.getToken();
      if (token) {
        const authReq = req.clone({ setHeaders: { 'X-ACCESS-TOKEN': token } });
        return next.handle(authReq);
      }
    }

    return next.handle(req);
  }
}
